/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import { useReducer } from 'react';
import { InfoCircle1 } from '../../icons/InfoCircle1';
import { Button } from '../Button';
import { Icon } from '../Icon';
import './style.css';

export const Input = ({
    showIcon = true,
    text = 'Email',
    showLabel = true,
    showHelpText = false,
    function1,
    stateProp,
    className,
    iconIcon = <InfoCircle1 className="info-circle" />,
    defaultTextValue = '',
    onChange,
}) => {
    const [state, dispatch] = useReducer(reducer, {
        function2: function1 || 'input',
        state: stateProp || 'default',
    });

    return (
        <div
            className={`input function-${state.function2} ${className}`}
            onClick={() => {
                dispatch('click');
            }}
        >
            {showLabel && <div className="text-wrapper-3">Suche</div>}

            <div className="frame-7">
                <div className={`content state-${state.state}`}>
                    <div className="field">
                        {/*
            // Commenting this out because otherwise input box extends filter box on right side
            <input className={`email function-0-${state.function2} state-0-${state.state}`} />*/}

                        <input
                            style={{ width: '100%', borderWidth: '0px' }}
                            placeholder={defaultTextValue}
                            onChange={(e) => {
                                if (null != onChange) {
                                    onChange(e);
                                }
                            }}
                        />

                        {state.function2 === 'input' &&
                            state.state === 'default' && (
                                <>
                                    <>
                                        {showIcon && (
                                            <Icon
                                                className="icon-instance"
                                                icon={iconIcon}
                                                property1="default"
                                            />
                                        )}
                                    </>
                                </>
                            )}
                    </div>
                </div>

                {state.function2 === 'input-and-submit' && (
                    <Button
                        className="button-2"
                        status="default"
                        style="secondary"
                        textLink="Subscribe"
                    />
                )}
            </div>

            {showHelpText && <div className="text-wrapper-4">Help Text</div>}
        </div>
    );
};

function reducer(state, action) {
    switch (action) {
        case 'click':
            return {
                ...state,
                state: 'focus',
            };
    }

    return state;
}

Input.propTypes = {
    showIcon: PropTypes.bool,
    text: PropTypes.string,
    showLabel: PropTypes.bool,
    showHelpText: PropTypes.bool,
    function1: PropTypes.oneOf(['input-and-submit', 'input']),
    stateProp: PropTypes.oneOf(['focus', 'default']),
};
